/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/url/RemoveQueryFromURL.ts
 * @create:      2025-06-28 09:09:01.265
 * @modify:      2025-07-11 21:19:12.796
 * @version:     6.0.0
 * @times:       5
 * @lines:       56
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Removes the query string from a given URL.
 *
 * @param url - The URL string to process.
 * @param keepHash - Optional. If true, preserves the hash fragment (if present) in the returned URL. Defaults to false.
 * @returns The URL without the query string. If `keepHash` is true and a hash fragment exists, it is preserved.
 * 
 * @since 4.0.0
 * @version 2021-12-11
 */
export function RemoveQueryFromURL(url: string, keepHash = false) {
    const index = url.indexOf("#");
    if (index !== -1) {
        const urlWithoutQuery = url.substring(0, index).split("?")[0];
        if (keepHash) {
            return urlWithoutQuery + url.substring(index);
        } else {
            return urlWithoutQuery;
        }
    } else {
        return url.split("?")[0];
    }
}
